module.exports = __webpack_public_path__ + "images/trash-c03778f7.svg";